import * as css from 'css/exports.module.scss';

import { coreActions } from '@sonar-software/sonar-core';
import { INITIATIVES_SIDEBAR_LABELS } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { SonarTagDisplay } from '@ui/tags';
import { SonarText } from '@ui/text';
import { Space } from 'antd';

import { useAction, useInitiativeReferenceSelect, useOnMount } from '@hooks';

export interface InitiativeTagsSectionProps {
	initiativeId: number;
}

export const InitiativeTagsSection: React.FC<InitiativeTagsSectionProps> = ({ initiativeId }) => {
	const tagIds = useInitiativeReferenceSelect(initiativeId, (initiative) => initiative.tagIds);

	const getTags = useAction(coreActions.requestGetCoreInitiativesTags);

	useOnMount(() => {
		getTags({
			initiativeId: initiativeId
		});
	});

	if (!tagIds.length) {
		return null;
	}

	return (
		<>
			<SonarText className='section-header'>{ INITIATIVES_SIDEBAR_LABELS.TAGS }</SonarText>
			<Space
				size={ Number(css.size2) }
				wrap>
				{ tagIds.map((tagId) =>
					<SonarTagDisplay
						key={ tagId }
						tagId={ tagId } />) }
			</Space>
		</>
	);
};
